import { render, staticRenderFns } from "./CommercialEfficiencyDashboard.vue.vue?vue&type=template&id=fb5678b4"
import script from "./CommercialEfficiencyDashboard.vue.vue?vue&type=script&lang=js"
export * from "./CommercialEfficiencyDashboard.vue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports